import Reflux from 'reflux';
import ErrorHandlerActions from '../ErrorHandlerActions';
import AlertActions from '../AlertActions';
import React from 'react';


var ErrorHandlerStore = Reflux.createStore({
    init: function() {
        this.listenToMany(ErrorHandlerActions);
    },

    /**
     * Verifies if there are errors in the response and returns
     * the payload if no errors were found
     *
     * @param {Object} json
     *
     * @return {json}
     */
    checkForErrors: function(json) {
        console.log(json);
        if(json.hasOwnProperty('statusCode') && json.type === 'validation') {
            this.throwValidationError(json.payload);
            throw Error('ValidationError');
        }
        else if (json.hasOwnProperty('error') && json.error === 'invalid_credentials') {
            const msg = <div>Su combinación de email/password es incorrecta</div>;
            this.trigger('auth_failed');
            AlertActions.alert('open', 'Error de Inicio de Sesión', msg);
            throw Error('Login Error');
        }

        else if (json.hasOwnProperty('error') && json.error === 'access_denied') {
            this.trigger('auth_failed');
            return 'denied';
        }
        else if (json.hasOwnProperty('error') && json.error === 'unknown') {
            AlertActions.alert('open', 'Error Desconocido', 'Se ha presentado un error desconocido en la aplicación, por favor refresque el navegador, si el problema persiste comuniquese con nosotros y con gusto le buscaremos solución al problema.');
            throw Error('Unknown Error');
        }

        else if (json.hasOwnProperty('error') && json.error === 'invalid_rif') {
            AlertActions.alert('open', 'El rif ingresado es Invalido, por favor revise el digito verificador');
            throw Error('Validation');
        }

        else if (json.hasOwnProperty('error') && json.error === 'timeout-seniat') {
            AlertActions.alert('open', 'Tiempo de espera agotado', 'La conexión al SENIAT no esta disponible por los momentos, por favor indique los datos manualmente <a target="_blank" href="http://contribuyente.seniat.gob.ve/BuscaRif/BuscaRif.jsp">Haga click aqui para consultar directamente en el SENIAT</a>');
            throw Error('Timeout');
        }

        else if (json.hasOwnProperty('error') && json.error === 'expired_suscription') {
            AlertActions.alert('open', 'Suscripción vencida', 'Su suscripción al servicio ha vencido, por favor solicite la reactivación del mismo.');
            throw Error('Expired');
        }

        else {
            return json;
        }
    },

    /**
     * Verifies if there are errors in the response and returns
     * the payload if no errors were found
     *
     * @param {Object} json
     *
     * @return {void}
     */
    throwValidationError: function(json) {

        let messages = [];

        Object.keys(json).forEach((key, i) => {
            messages[i] = <li key={i}>{key}: {json[key]}</li>;
        });

        let list = <ul style={{marginLeft:0, paddingLeft:20}}>{messages}</ul>;
        this.trigger();
        AlertActions.alert('open', 'Error de Validacion', list);
    },


});

export default ErrorHandlerStore;



/** WEBPACK FOOTER **
 ** ./app-react/reflux/stores/ErrorHandlerStore.js
 **/